import store from '@/store';

export function clearAll() {
  store.dispatch('admin/clearAll', null, { root: true });
  store.dispatch('mqtt/clearAll', null, { root: true });
  store.dispatch('socket/clearAll', null, { root: true });
}
